import { render, staticRenderFns } from "./DescriptionTableCell.vue?vue&type=template&id=64828520&scoped=true"
import script from "./DescriptionTableCell.vue?vue&type=script&lang=js"
export * from "./DescriptionTableCell.vue?vue&type=script&lang=js"
import style0 from "./DescriptionTableCell.vue?vue&type=style&index=0&id=64828520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64828520",
  null
  
)

export default component.exports